export default __webpack_public_path__ + "static/media/24_Business-ProductArchitecture-InteriorEschweilerPhotographybebe_moon11_.efc8f5bf.jpg";